import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import ContactSection from "@/components/ContactSection";
import {
  ArrowRight,
  MapPin,
  Users,
  Code2,
  Rocket,
  Target,
  Heart,
  Building2,
  CheckCircle2,
  Lightbulb,
  Shield,
} from "lucide-react";

const technologies = [
  {
    name: "PHP",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-plain.svg",
    bg: "#777BB4",
  },
  {
    name: "Python",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
    bg: "#3776AB",
  },
  {
    name: "Java",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
    bg: "white",
  },
  {
    name: "ReactJS",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
    bg: "#23272F",
  },
  {
    name: "Node.js",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
    bg: "#215732",
  },
  {
    name: "Laravel",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/laravel/laravel-original.svg",
    bg:   "white",
  },
  {
    name: "Symfony",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/symfony/symfony-original.svg",
    bg:   "white",
  },
  {
    name: "JavaScript",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
    bg: "#323330",
  },
  {
    name: "TypeScript",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
    bg: "#3178C6",
  },
  {
    name: "MySQL",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
    bg: "white",
  },
  {
    name: "PostgreSQL",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg",
    bg: "#336791",
  },
  {
    name: "SQLServer",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/microsoftsqlserver/microsoftsqlserver-plain.svg",
    bg: "transparent",
  },
  {
    name: "Docker",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
    bg: "#1D63ED",
  },
  {
    name: "Vue.js",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg",
    bg: "#1B2A32",
  },
  {
    name: "Angular",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg",
    bg: "#B52E31",
  },
  {
    name: "Nginx",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nginx/nginx-original.svg",
    bg: "transparent",
  },
  {
    name: "OpenAPI",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/openapi/openapi-plain.svg",
    bg: "transparent",
  },
 {
    name: "Swagger",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/swagger/swagger-plain.svg",
    bg: "transparent",
  },
{
    name: "Amazon Web Services",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-plain-wordmark.svg",
    bg: "transparent",
  },
  
  

];

const values = [
  {
    icon: Target,
    title: "Soluciones a medida",
    description:
      "Cada proyecto es único. Analizamos tus necesidades y construimos exactamente lo que tu negocio requiere, sin soluciones genéricas.",
  },
  {
    icon: Rocket,
    title: "Tecnología de vanguardia",
    description:
      "Usamos las tecnologías más modernas y probadas del mercado para garantizar rendimiento, escalabilidad y seguridad en cada entrega.",
  },
  {
    icon: Heart,
    title: "Compromiso con el cliente",
    description:
      "Tu éxito es el nuestro. Acompañamos cada proyecto desde el análisis inicial hasta la puesta en producción y el soporte posterior.",
  },
  {
    icon: Shield,
    title: "Calidad garantizada",
    description:
      "Aplicamos metodologías ágiles, revisiones de código y pruebas exhaustivas para entregar software robusto y libre de errores críticos.",
  },
  {
    icon: Lightbulb,
    title: "Innovación continua",
    description:
      "Nos mantenemos actualizados en las últimas tendencias del sector para ofrecerte siempre las mejores herramientas y enfoques.",
  },
  {
    icon: Users,
    title: "Equipo multidisciplinar",
    description:
      "Contamos con especialistas en backend, frontend, bases de datos, DevOps y marketing digital trabajando de forma coordinada.",
  },
];

const stats = [
  { value: "+8", label: "Años de experiencia" },
  { value: "+150", label: "Proyectos entregados" },
  { value: "+60", label: "Clientes satisfechos" },
  { value: "24/7", label: "Soporte técnico" },
];

const QuienesSomos = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "erm-media",
    url: "https://erm-media.com",
    description:
      "Grupo de desarrolladores informáticos ubicados en la Comunidad de Madrid, especializados en desarrollo de software a medida para PYMES y grandes empresas.",
    address: {
      "@type": "PostalAddress",
      addressRegion: "Comunidad de Madrid",
      addressCountry: "ES",
    },
    knowsAbout: [
      "PHP",
      "Python",
      "Java",
      "ReactJS",
      "Node.js",
      "Laravel",
      "Symfony",
    ],
  };

  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Contacto"
        description="Contacta con nosotros para solicitar información sobre nuestros servicios de desarrollo de software a medida. PHP, Python, Java, ReactJS, Laravel, Symfony y más."
        keywords="contacto, empresa desarrollo software Madrid, desarrolladores informaticos Madrid, desarrollo a medida, PYMES, software empresarial"
        canonicalUrl="https://erm-media.com/contacto"
        structuredData={structuredData}
      />
      <Header />

      

               <ContactSection />


      {/* Technology Carousel Section */}
      <section className="py-20 overflow-hidden">
        <div className="container mx-auto px-4 mb-12 text-center">
          <div className="inline-flex items-center gap-2 bg-primary/10 text-primary px-4 py-2 rounded-full mb-6">
            <Code2 className="w-4 h-4" />
            <span className="text-sm font-medium">Nuestro stack tecnológico</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Tecnologías que dominamos
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Trabajamos con las herramientas y lenguajes más demandados del
            mercado para construir soluciones robustas y escalables.
          </p>
        </div>


        {/* Infinite scrolling carousel */}
        <div className="relative w-full">
          <style>{`
            @keyframes marquee {
              0% { transform: translateX(0); }
              100% { transform: translateX(-50%); }
            }
            .marquee-track {
              animation: marquee 30s linear infinite;
            }
            .marquee-track:hover {
              animation-play-state: paused;
            }
          `}</style>

          {/* Fade edges */}
          <div className="absolute left-0 top-0 bottom-0 w-24 z-10 pointer-events-none bg-gradient-to-r from-background to-transparent" />
          <div className="absolute right-0 top-0 bottom-0 w-24 z-10 pointer-events-none bg-gradient-to-l from-background to-transparent" />

          <div className="flex overflow-hidden">
            <div className="marquee-track flex gap-6 items-center">
              {/* Render twice for seamless loop */}
              {[...technologies, ...technologies].map((tech, index) => (
                <div
                  key={`${tech.name}-${index}`}
                  className="flex flex-col items-center gap-3 shrink-0 group cursor-default"
                  title={tech.name}
                >
                  <div
                    className="w-20 h-20 rounded-2xl flex items-center justify-center shadow-md group-hover:shadow-lg group-hover:scale-110 transition-all duration-300"
                    style={{ backgroundColor: tech.bg }}
                  >
                    <img
                      src={tech.icon}
                      alt={tech.name}
                      className="w-12 h-12 object-contain"
                      loading="lazy"
                    />
                  </div>
                  <span className="text-xs font-medium text-muted-foreground group-hover:text-foreground transition-colors whitespace-nowrap">
                    {tech.name}
                  </span>
                </div>
              ))}
            </div>
          </div>



        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary/5 border-t border-border/50">
        <div className="container mx-auto px-4 text-center">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
              ¿Listo para impulsar tu negocio?
            </h2>
            <p className="text-muted-foreground text-lg mb-8 leading-relaxed">
              Cuéntanos tu proyecto y te preparamos una propuesta personalizada
              sin compromiso. Estamos en Madrid y trabajamos con empresas de
              toda España.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="/contacto#contacto">
                <Button size="lg" className="group">
                  Contactar ahora
                  <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
                </Button>
              </a>
              <a href="/#servicios">
                <Button size="lg" variant="outline">
                  Explorar servicios
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default QuienesSomos;
